const Joi = require('joi');
const minPassword = 8;

const registerSchema = Joi.object({
	email: Joi.string()
		.email({ tlds: { allow: false } }) // Valida se é um email válido
		.required(),
	password: Joi.string().min(minPassword).required(),
	cpf: Joi.string().min(11).max(11).required(),
}).messages({
	'any.required': 'Todos os campos devem ser preenchidos',
});

module.exports = { registerSchema };
